import React, { useEffect, useState } from 'react';
import pt from 'prop-types';
import CustomScrollable from '../../../../ui/customScrollable';
import TeaserItem from '../../../../ui/teaserItem';
import FirstItem from '../firstItem';
import { headlinePropTypes } from '../../../../ui/headline';
import { linkProptypes } from '../../../../ui/link';
import * as styles from './styles.module.scss';

import { getAPIRoot } from '../../../../../helpers/fetch';
import { API_ROUTES } from '../../../../../utils/constants';

const RandomCompanies = ({
  amountOfRandomTeaser,
  firstItemHeadline,
  firstItemText,
  firstItemLink,
  setTotal,
  isCreative,
  layout,
  profileTypeId,
}) => {
  const [companies, setCompanies] = useState([]);

  const fetchCompanies = async () => {
    let apiRoot = await getAPIRoot();

    await fetch(
      `${apiRoot}${API_ROUTES.RANDOM_COMPANIES}/${
        isCreative ? 'creatives/' : ''
      }${amountOfRandomTeaser}${profileTypeId ? `/${profileTypeId}` : ''}`
    )
      .then((res) => res.json())
      .then((res) => {
        const data = res.items.map((item) => {
          return {
            image: { url: item.image, description: item.companyName },
            title: item.companyName,
            info: item.firstClient,
            imageBadge: item.logo,
            link: { linkToPage: item.slug },
          };
        });
        setCompanies(data);
        setTotal(res.count);
      });
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  if (layout === 'grid') {
    return (
      <div className={styles.gridContainer}>
        {companies.length > 0
          ? companies.map((item, index) => <TeaserItem key={index} {...item} />)
          : Array.from(Array(6).keys()).map((_, index) => (
              <TeaserItem key={index} isSkeleton />
            ))}
      </div>
    );
  }

  return (
    <>
      <CustomScrollable className={styles.scrollContainer}>
        {firstItemHeadline && (
          <FirstItem
            headline={firstItemHeadline}
            text={firstItemText}
            link={firstItemLink}
          />
        )}
        <div className={styles.innerContainer}>
          {companies.length > 0
            ? companies.map((item, index) => (
                <TeaserItem key={index} {...item} isInSlider />
              ))
            : Array.from(Array(3).keys()).map((_, index) => (
                <TeaserItem key={index} isSkeleton isInSlider />
              ))}
        </div>
      </CustomScrollable>
      <CustomScrollable className={styles.scrollContainerSm}>
        <div className={styles.innerContainerSm}>
          {companies.length > 0
            ? companies.map((item, index) => (
                <TeaserItem key={index} {...item} isInSlider />
              ))
            : Array.from(Array(3).keys()).map((_, index) => (
                <TeaserItem key={index} isSkeleton isInSlider />
              ))}
        </div>
      </CustomScrollable>
    </>
  );
};

RandomCompanies.propTypes = {
  amountOfRandomTeaser: pt.number.isRequired,
  firstItemHeadline: pt.shape(headlinePropTypes),
  firstItemText: pt.string,
  firstItemLink: pt.shape(linkProptypes),
  setTotal: pt.func,
  isCreative: pt.bool,
  layout: pt.oneOf(['slider', 'grid']),
  profileTypeId: pt.string,
};

RandomCompanies.defaultProps = {
  firstItemHeadline: null,
  firstItemText: '',
  firstItemLink: null,
  setTotal: () => {},
  isCreative: false,
  layout: 'slider',
  profileTypeId: '',
};

export default RandomCompanies;
